import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { messages } from './messages';

import style from './style.module.css';

// TODO: Update defaultMessage based on work from SPD-6891
export const DriverTipTooltip = () => (
  <Tooltip>
    <TooltipContent>
      <FormattedMessage {...messages.driverTipTooltip} />
    </TooltipContent>
    <div className={style['icon-wrapper']}>
      <FontAwesomeIcon className={style.icon} icon={faInfoCircle} />
    </div>
  </Tooltip>
);
